import $ from 'jquery';

const skipLink = $('.skip-link');

skipLink.on('click', function(event) {
  event.preventDefault();
  const targetId = $(this).attr('href');
  $('html, body').animate({
    scrollTop: $(targetId).offset().top}, 500, function() {
    $(targetId).attr('tabindex', '-1').focus();
  });
});

